import React from 'react';
import PropTypes from 'prop-types';

import useBazaarVoice from 'hooks/useBazaarVoice';
import BVHelmet from './BVHelmet';

const BVReviews = ({ productId }) => {
  useBazaarVoice();

  if (!productId) return null;

  return (
    <>
      <BVHelmet />
      <div data-bv-show="reviews" data-bv-product-id={productId} />
    </>
  );
};

BVReviews.propTypes = {
  productId: PropTypes.string,
};

export default BVReviews;
